import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { useTranslation } from 'react-i18next';
import { useHeaderData, useHeaderDisplayLogic } from '../../helpers';
import { HeaderCounter } from './HeaderCounter';

interface HeaderCountersProps {
  isMobile?: boolean;
}

export function HeaderCounters({ isMobile }: HeaderCountersProps) {
  const { t } = useTranslation();
  const { followers = 0, following = 0, likes = 0 } = useHeaderData();

  const {
    shouldShowFollowingCount,
    shouldShowFollowersCount,
    shouldShowLikesCount
  } = useHeaderDisplayLogic();

  if (
    !shouldShowFollowingCount &&
    !shouldShowFollowersCount &&
    !shouldShowLikesCount
  ) {
    return null;
  }

  return (
    <Container>
      <Show when={shouldShowFollowingCount}>
        <HeaderCounter
          count={following}
          text={t('Following')}
          isMobile={isMobile}
        />
      </Show>

      <Show when={shouldShowFollowersCount}>
        <HeaderCounter
          count={followers}
          text={t('Followers')}
          isMobile={isMobile}
        />
      </Show>

      <Show when={shouldShowLikesCount}>
        <HeaderCounter count={likes} text={t('Likes')} isMobile={isMobile} />
      </Show>
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'header-counters',
    element: 'container'
  })
})`
  display: flex;
  justify-content: center;
  gap: 16px;
`;
